import React from "react";
import { Redirect, Route } from "react-router-dom";
import { AuthClient } from "../repository/auth";
export default ({ path, exact, children }) => {
    return AuthClient.tokens.accessToken ? (React.createElement(Route, { exact: exact, path: path }, children)) : (React.createElement(Redirect, { to: "/" }));
};
//# sourceMappingURL=PrivateRoute.js.map